import {RadarEsgState} from "../pages/Esg/EsgDashboard.type";
import {
  Cluster,
  IobrDataServerForRadarClusters,
  IobrDataServerForRadarDirections,
  ITypeRadar,
  RadarData,
} from "../types";
import {RadarFintechState} from "../pages/Fintech/FintechDashboard.type";
import {
  Icluster,
  IClustersForRadar,
  IClustersForRadarMolecula,
  ICLusterTehnologieData,
  IDataForRadarMolecula,
  IinitialStateServerMolecula,
} from "../pages/Dashboard/Dashboard.type";
import {
  Iinitiatives,
  InitiativeRadar,
} from "../pages/StateInitiative/StateInitiative.type";
import {fetchTechnologyData} from "./requests";

let previousTypeRadar: ITypeRadar | null = null;
let clustersNew: IobrDataServerForRadarClusters[] = [];

const mapValueToTrendScore = (value: number): number => {
  if (value < 10) {
    return (value / 10) * 50;
  } else if (value < 100) {
    return 50 + ((value - 10) / 90) * 30;
  } else if (value < 1000) {
    return 80 + ((value - 100) / 900) * 50;
  } else if (value < 10000) {
    return 130 + ((value - 1000) / 9000) * 30;
  } else if (value < 100000) {
    return 160 + ((value - 10000) / 90000) * 20;
  } else {
    return 180 + ((value - 100000) / 400000) * 10;
  }
};

export const ChangeDataForRadar = (
  dataCluster:
    | RadarData
    | RadarEsgState
    | RadarFintechState
    | IDataForRadarMolecula
    | Iinitiatives,
  typeRadar: ITypeRadar,
  isWeak_signal?: boolean,
  dataMoleculaActive?: ICLusterTehnologieData[] | undefined
) => {
  if (typeRadar === "map") {
    clustersNew =
      (dataCluster as RadarData)?.clusters.map((item: Cluster) => {
        const existingCluster = clustersNew.find(
          (cluster) => cluster.id === item.id
        );
        return {
          id: item.id,
          direction_id: item.direction_id,
          maturity: item.maturity,
          isLabelShown: item.isLabelShown ?? false,
          size: item.invest_volume_tier + item.market_volume_tier,
          name: item.name!,
          x: previousTypeRadar !== typeRadar ? undefined : existingCluster?.x,
          y: previousTypeRadar !== typeRadar ? undefined : existingCluster?.y,
        };
      }) || [];
    const directions: IobrDataServerForRadarDirections[] = (
      dataCluster as RadarData
    )?.directions.map((data) => {
      return {
        id: data.id,
        name: data.name,
        nptl: data.nptl,
      };
    });
    previousTypeRadar = typeRadar;
    return {clustersNew, directions};
  }
  if (typeRadar === "molecula") {
    let newArrMolecule: ICLusterTehnologieData[] = [];
    if (dataMoleculaActive) {
      newArrMolecule = dataMoleculaActive?.filter(
        (cluster, index, self) =>
          self.findIndex((c) => c.cluster_id === cluster.cluster_id) === index
      );
    }

    clustersNew = (dataCluster as IDataForRadarMolecula)?.clusters
      .map((item: IClustersForRadar) => {
        if (newArrMolecule.find((itemMol) => itemMol.cluster_id === item.id)) {
          return {
            id: item.id,
            idNumber: item.idNumber,
            direction_id: item.direction_id,
            maturity: item.maturity,
            isLabelShown: item.isLabelShown ?? false,
            size: 1,
            name: item.name!,
            connection: newArrMolecule.find(
              (itemMol) => itemMol.cluster_id === item.id
            )?.strength,
            tehnologies: newArrMolecule
              .filter((itech) => itech.cluster_id === item.id)
              .flatMap((itech) =>
                itech.technologies.map((iT) => ({
                  documentId: iT.documentId,
                  id: iT.id,
                  name: iT.name,
                }))
              ),
          };
        }
        return null;
      })
      .filter(
        (item) => item !== null
      ) as unknown as IobrDataServerForRadarClusters[];

    const directions: IobrDataServerForRadarDirections[] = (
      dataCluster as RadarData
    )?.directions.filter((data) => {
      if (clustersNew.find((itemMol) => itemMol.direction_id === data.id)) {
        return true;
      }
      return false;
    });

    return {clustersNew, directions};
  }
  if (typeRadar === "moleculeTwo") {
    let newArrMolecule: ICLusterTehnologieData[] = [];
    if (dataMoleculaActive) {
      newArrMolecule = dataMoleculaActive?.filter(
        (cluster, index, self) =>
          self.findIndex((c) => c.cluster_id === cluster.cluster_id) === index
      );
    }

    clustersNew = newArrMolecule
      .map((item) => {
        return {
          id: item.cluster_id,
          direction_id: item.direction_id,
          maturity:
            item.strength === 1
              ? "Концепт"
              : item.strength === 2
              ? "Прототип"
              : "Продукт",
          isLabelShown: false,
          size: 1,
          name: item.name,
          connection: item.strength,
          tehnologies: newArrMolecule
            .filter((itech) => itech.cluster_id === item.cluster_id)
            .flatMap((itech) =>
              itech.technologies.map((iT) => ({
                documentId: iT.documentId,
                id: iT.id,
                name: iT.name,
              }))
            ),
        };
      })
      .filter(
        (item) => item !== null
      ) as unknown as IobrDataServerForRadarClusters[];

    const directions: IobrDataServerForRadarDirections[] = (
      dataCluster as RadarData
    )?.directions.filter((data) => {
      if (clustersNew.find((itemMol) => itemMol.direction_id === data.id)) {
        return true;
      }
      return false;
    });
    return {clustersNew, directions};
  }
  if (typeRadar === "stateInitiative") {
    if (
      (dataCluster as Iinitiatives)?.initiatives &&
      (dataCluster as Iinitiatives)?.directions
    ) {
      clustersNew =
        (dataCluster as Iinitiatives)?.initiatives.map(
          (item: InitiativeRadar) => {
            const existingCluster = clustersNew.find(
              (cluster) => cluster.id === item.documentId
            );

            const lifecycleStageMapping = (lifecycleStage: string): string => {
              switch (lifecycleStage) {
                case "Общественное обсуждение":
                  return "Концепт";
                case "Пилот":
                  return "Прототип";
                case "Масштабирование":
                  return "Продукт";
                default:
                  return "Прототип";
              }
            };

            let maturityValue: string;
            if (item.lifecycle_stage) {
              maturityValue = lifecycleStageMapping(item.lifecycle_stage);
            } else {
              const numValue =
                typeof item.maturity === "string"
                  ? parseInt(item.maturity)
                  : item.maturity;
              if (numValue <= 30) maturityValue = "Концепт";
              else if (numValue <= 70) maturityValue = "Прототип";
              else maturityValue = "Продукт";
            }

            const result = {
              id: item.documentId,
              direction_id: item?.segment?.id,
              maturity: maturityValue,
              isLabelShown: item.isLabelShown ?? false,
              size: item.statusInBank,
              name: item.name!,
              x:
                previousTypeRadar !== typeRadar
                  ? undefined
                  : existingCluster?.x,
              y:
                previousTypeRadar !== typeRadar
                  ? undefined
                  : existingCluster?.y,
              trend_score: 50,
              pointStart: 0,
              pointEnd: 100,
            };
            return result;
          }
        ) || [];

      const directions: IobrDataServerForRadarDirections[] = (
        dataCluster as Iinitiatives
      )?.directions.map((data) => {
        return {
          id: data.id,
          name: data.name,
        };
      });

      previousTypeRadar = typeRadar;
      return {clustersNew, directions};
    }
  }
  if (typeRadar === "esg") {
    clustersNew = (dataCluster as RadarEsgState)?.projects.map((data) => {
      const existingCluster = clustersNew.find(
        (cluster) => cluster.id === data.id
      );
      return {
        id: data.id,
        direction_id: data.direction_id,
        maturity: data.maturity_stage,
        isLabelShown: data.isLabelShown ?? false,
        size: data.rank_tier,
        name: data.name!,
        x: previousTypeRadar !== typeRadar ? undefined : existingCluster?.x,
        y: previousTypeRadar !== typeRadar ? undefined : existingCluster?.y,
      };
    });
    const directions: IobrDataServerForRadarDirections[] = (
      dataCluster as RadarEsgState
    )?.directions.map((data) => {
      return {
        id: data.id,
        name: data.direction,
      };
    });
    previousTypeRadar = typeRadar;
    return {clustersNew, directions};
  }
  if (typeRadar === "fintech") {
    let directions: IobrDataServerForRadarDirections[];
    if (!isWeak_signal) {
      clustersNew = (dataCluster as RadarFintechState)?.trends
        .filter((data) => data.sector !== null)
        .map((data) => {
          return {
            id: data.documentId,
            direction_id: data.sector.id,
            maturity: "Концепт",
            isLabelShown: data.isLabelShown ?? false,

            size: data.market_volume_tier!,
            name: data.name!,
            trend_score: mapValueToTrendScore(
              data.market_volume_forecast! || 100000
            ),
            trend_score_world: mapValueToTrendScore(
              data.market_volume_forecast! || 100000
            ),
          };
        });
      directions = (dataCluster as RadarFintechState)?.directions.map(
        (data) => {
          return {
            id: data.id,
            name: data.name,
          };
        }
      );
    } else {
      clustersNew = (dataCluster as RadarFintechState)?.weak_signals.map(
        (data) => {
          return {
            id: data.id,
            direction_id: data.segment_id ?? 1,
            maturity:
              data.frequency === "\u0412\u044b\u0441\u043e\u043a\u0430\u044f"
                ? "Концепт"
                : "Прототип",
            isLabelShown: data.isLabelShown ?? false,
            x: data.x || 0,
            y: data.y || 0,
            size: 3,
            name: data.title!,
            trend_score: 3,
          };
        }
      );
      directions = [
        {
          id: 0,
          name: "\u041d\u043e\u0432\u044b\u0435 \u0441\u043f\u043e\u0441\u043e\u0431\u044b \u043e\u043f\u043b\u0430\u0442\u044b",
        },
        {
          id: 1,
          name: "\u0423\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435 \u0434\u0430\u043d\u043d\u044b\u043c\u0438 \u0438 \u0430\u043d\u0430\u043b\u0438\u0442\u0438\u043a\u0430",
        },
        {
          id: 2,
          name: "\u0411\u043b\u043e\u043a\u0447\u0435\u0439\u043d-\u0442\u0435\u0445\u043d\u043e\u043b\u043e\u0433\u0438\u0438",
        },
        {
          id: 3,
          name: "\u0418\u043d\u043d\u043e\u0432\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0435 \u0444\u0438\u043d\u0430\u043d\u0441\u043e\u0432\u044b\u0435 \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u044b \u0438 \u0443\u0441\u043b\u0443\u0433\u0438",
        },
        {
          id: 4,
          name: "\u0420\u0435\u0433\u0443\u043b\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435, \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u043e\u0441\u0442\u044c \u0438 \u0443\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435 \u0440\u0438\u0441\u043a\u0430\u043c\u0438",
        },
        {
          id: 5,
          name: "\u0426\u0438\u0444\u0440\u043e\u0432\u044b\u0435 \u0444\u0438\u043d\u0430\u043d\u0441\u043e\u0432\u044b\u0435 \u0430\u043a\u0442\u0438\u0432\u044b \u0438 \u0446\u0438\u0444\u0440\u043e\u0432\u0430\u044f \u0432\u0430\u043b\u044e\u0442\u0430",
        },
        {
          id: 6,
          name: "\u0418\u043c\u043f\u0430\u043a\u0442-\u0440\u0435\u0448\u0435\u043d\u0438\u044f",
        },
        {
          id: 7,
          name: "\u0418\u043d\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0438 \u0438 \u0443\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435 \u0430\u043a\u0442\u0438\u0432\u0430\u043c\u0438",
        },
      ];
      // (dataCluster as RadarFintechState)?.directions
      //   .filter((_, index) => index === 0)
      //   .map((data) => {
      //     return {
      //       id: data.id,
      //       name: data.name,
      //     };
      //   }) || [];
    }

    return {clustersNew, directions};
  }
};
